import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row
} from 'reactstrap';
import Header from '../components/Headers/Header';
import Profile from './settingsViews/Profile';
import NotePreferences from './settingsViews/NotePreferences';
import AdminPortal from './settingsViews/AdminPortal';
import MultiFactorAuth from './settingsViews/MultiFactorAuth';
import { fetchUserDetails } from '../components/Misc/apiUtils'; // Import your API utility function
import { GlobalContext } from '../api/GlobalContext';

const UserSettings = ({ onClose }) => {
  const { apiClient } = useContext(GlobalContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const defaultActiveTab = queryParams.get('activeTab') || 'profile';
  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    // Fetch user details when the component mounts
    fetchUserDetails(apiClient)
      .then((data) => setUserDetails(data))
      .catch((error) => console.error('Error fetching user details:', error));
  }, []);

  const tabs = {
    profile: { title: 'Profile', Component: Profile },
    notePreferences: { title: 'Note Preferences', Component: NotePreferences },
    multiFactorAuth: {
      title: 'Multi Factor Authentication',
      Component: MultiFactorAuth
    }
  };

  const buttonStyle = {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    marginBottom: '0.5rem',
    padding: '0.75rem 1.25rem',
    border: 'none',
    boxShadow: 'none',
    borderColor: 'transparent'
  };
  const renderTabButtons = () => {
    return Object.keys(tabs).map((tabKey) => {
      const isActive = activeTab === tabKey;
      const activeStyle = {
        backgroundColor: isActive ? '#6bd888' : 'transparent',
        color: isActive ? 'white' : 'black  '
      };

      return (
        <Button
          key={tabKey}
          onClick={() => setActiveTab(tabKey)}
          style={{ ...buttonStyle, ...activeStyle }}
        >
          {tabs[tabKey].title}
        </Button>
      );
    });
  };

  const renderActiveTabContent = () => {
    const ActiveTabComponent = tabs[activeTab].Component;
    return <ActiveTabComponent userDetails={userDetails} />;
  };

  return (
    <>
      <Header isLite={true} />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 header-flex">
                <h3 className="mb-0">User Settings (Beta)</h3>
              </CardHeader>
              <Row>
                {/* This column is for the vertical tabs */}
                <Col md="3">
                  <div>{renderTabButtons()}</div>
                </Col>
                {/* Vertical divider */}
                <div
                  style={{
                    borderLeft: '1px solid #ddd',
                    height: 'auto',
                    paddingTop: '1rem'
                  }}
                />
                {/* This column is for the content of the active tab */}
                <Col md="8" style={{ paddingTop: '-3rem' }}>
                  {' '}
                  {/*not working...*/}
                  <CardBody>{renderActiveTabContent()}</CardBody>
                </Col>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default UserSettings;
